module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-2400.b57384bc.svg";